(function () {
  function initPressureWasher(section) {
    if (!section || section.dataset.pressureReady === "true") return;
    section.dataset.pressureReady = "true";

    section.querySelectorAll("[data-pressure-add]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled) return;

        var kitSection = document.querySelector("[data-complete-kit]");
        if (!kitSection) return;

        var index = btn.getAttribute("data-kit-index");
        var variantId = btn.getAttribute("data-variant-id");

        document.dispatchEvent(
          new CustomEvent("complete-kit:open", {
            detail: {
              index: index != null ? Number(index) : null,
              variantId: variantId ? Number(variantId) : null,
            },
          })
        );
      });
    });
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll("[data-pressure-washer]").forEach(initPressureWasher);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    initAll(event.target);
  });
})();
